module.exports = __webpack_public_path__ + "img/person_lizixu.2042a9f9.jpg";